import { React, DomeComponent, DomeManipulator, DomeRouter } from "@lexriver/dome";
import css from './BasketSmall.m.scss'
import { UrlGenerator } from "../UrlGenerator";
import { Link } from "./Link";
import { GlobalState } from "../GlobalState";
import { Settings } from "../../Settings";
//import { EnumDomeEventDispatcherEvents } from "../EnumDomeEventDispatcherEvents.ts.old";
import cssAnimation from '../Animation.m.scss'
import { LoadingSpinnerForButton } from "./LoadingSpinnerForButton";
import { JsonBasketStats } from "../json-data-types/JsonBasketStats";
import { GlobalBasket } from "../GlobalBasket";
import { GlobalUser } from "../GlobalUser";
import { ServerSettings } from "../server-queries/ServerSettings";
import { EnumIconNames } from "../enums/EnumIconNames";
import { Basket } from "./Basket";
import { IBasket } from "../Basket/IBasket";
import { Price } from "./Price";
import { Currency } from "../../Currency";

interface Attrs{

}

export class BasketSmall extends DomeComponent<Attrs>{
    refDivBasketStatsContainer?:HTMLDivElement
    refDivBasketHeaderContainer?:HTMLDivElement
    refDivBasketButtonContainer?:HTMLDivElement

    render(){
        return (
            <div class={css.basketSmall}>
                <div class={css.basketHeader} ref={ref => this.refDivBasketHeaderContainer = ref}>
                    <Link url={UrlGenerator.basket()}>
                        <span class="icon-shopping-basket" style={{fontSize:"20px", margin:'5px'}}  ></span>
                        <span style={{fontSize:'20px'}}>Корзина</span>
                    </Link>
                </div>
                <div ref={ref => this.refDivBasketStatsContainer = ref} class={css.basketStats}><LoadingSpinnerForButton /></div>
                <div class={css.basketButtonContainer} ref={ref => this.refDivBasketButtonContainer = ref}></div>
                
            </div>
        )
    }
    async afterRender(){
        //GlobalState.basketSmallDiv = this.rootElement as HTMLDivElement
        this.scheduleUpdate()

        //console.log('### BasketSmall afterRender subscribing to basket-update!')
        GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
            //console.log('### BasketSmall onBasketUpdateEvent!')
            if(!DomeManipulator.isInDom(this.rootElement)) return {unsubscribe:true}
            this.scheduleUpdate()
        })

        // GlobalUser.loggedInUserO.eventOnChange.subscribe(async () => {
        //     this.scheduleUpdate()
        // })
    
    }

    async updateAsync(){
        //console.log('### BasketSmall update!')
        if(!this.refDivBasketStatsContainer) return
        if(!this.refDivBasketButtonContainer) return
        if (!this.refDivBasketHeaderContainer) return

        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        const cBasketStats = await basket.getStatsAsync({getJsonOrderItems:false})
        await DomeManipulator.replaceAllChildrenAsync(
            this.refDivBasketStatsContainer, 
            await this.renderBasketStatsAsync(cBasketStats), 
            //{cssClassName:cssAnimation.fadeOut1000, timeMs:1000}, 
            undefined,
            {cssClassName:cssAnimation.basketText, timeMs: 300}
            )
        //DomeManipulator.replaceAllChildrenAsync(this.refDivBasketStatsContainer, this.renderBasketStats(cBasketStats))

        await DomeManipulator.replaceAllChildrenAsync(this.refDivBasketButtonContainer, this.renderBasketButton(cBasketStats))
        // if (this.refDivBasketButtonContainer) {
        //     const zeroToSomeTransformation = basketStats.totalQuantity > 0 && this.refDivBasketButtonContainer.hasChildNodes() == false
        //     const someToZeroTransformation = basketStats.totalQuantity == 0 && this.refDivBasketButtonContainer.hasChildNodes()
        //     if (zeroToSomeTransformation || someToZeroTransformation) {
        //         DomeManipulator.replaceAllChildrenAsync(this.refDivBasketButtonContainer, this.renderBasketButton(basketStats))
        //     }
        // }

        
        await DomeManipulator.addCssClassAsync(this.refDivBasketHeaderContainer, cssAnimation.basketHeader, 400)
        // this.refDivBasketHeaderContainer.classList.add(cssAnimation.basketHeader)
        // setTimeout(() => {
        //     if(!this.refDivBasketHeaderContainer) return
        //     this.refDivBasketHeaderContainer.classList.remove(cssAnimation.basketHeader)
        // }, 400)
        


    }



    async renderBasketStatsAsync(basketStats: JsonBasketStats){
        if(basketStats.totalQuantity == 0){
            return <div>Выберите и добавьте свой первый товар в&nbsp;корзину</div>
        }

        if(await GlobalUser.checkIfCanSeeWholesalePricesAsync()){
            //wholesale basket
            const minWholesaleOrder = Number(await ServerSettings.getOnlyValueAsync('min-wholesale-order'))
            const dollarPrice =  Currency.roundTo2Decimals(basketStats.wholesaleSum / basketStats.wholesaleSumDollar)
            let remain:number = minWholesaleOrder-basketStats.wholesaleSum
            let remainDollar:number = Currency.roundTo2Decimals(remain/dollarPrice)
            return <div>
                <div>Всего товаров: <strong>{basketStats.totalQuantity}</strong></div>
                {/* <div>розн. сумма: <strong>{Settings.formatNumberToPrice(basketStats.retailSum)}</strong></div> */}
                <div>опт. сумма: 
                    <strong>
                    {/* {Settings.formatNumberToPrice(basketStats.wholesaleSum)} */}
                    <Price price={basketStats.wholesaleSum}  priceInDollar={basketStats.wholesaleSumDollar} />
                    </strong>
                </div>
                {(remain>0 && remain<minWholesaleOrder) &&
                    <div>еще до опт. заказа: <span class={css.needMore}>
                        {/* {Settings.formatNumberToPrice(remain)} */}
                        <Price price={remain} priceInDollar={remainDollar} />
                        </span>
                    </div>
                }
            </div>
        } else {
            //retail basket
            return <div>
                <div>Всего товаров: <strong>{basketStats.totalQuantity}</strong></div>
                <div>на сумму: <strong>
                    {/* {Settings.formatNumberToPrice(basketStats.retailSum)} */}
                    <Price price={basketStats.retailSum} priceInDollar={basketStats.retailSumDollar} />
                    </strong>
                </div>
            </div>
        }
    }

    renderBasketButton(basketStats: JsonBasketStats){
        if(basketStats.totalQuantity>0){
            return <>
                <div><button onClick={() => DomeRouter.navigate(UrlGenerator.basket())}>Перейти в корзину</button></div>
                <div><button onClick={() => DomeRouter.navigate(UrlGenerator.makeOrder())}>Оформить заказ</button></div>
                <div style={{paddingTop:'30px'}}>{Basket.renderDropBasketLink()}</div>
            </>
        }
        return null
    }


    
}

